import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from '@/app/app.routes';
import { authInterceptor } from '@/app/core/services/auth.interceptor';
import { authErrorInterceptor } from '@/app/core/services/auth-error.interceptor';

import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from '@/app/core/utils/app-title-strategy.utils';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, authErrorInterceptor])),

    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },
  ],
};
